import { Box, FlexProps } from 'rebass';
import React from 'react';

type FormRowProps = FlexProps & {
  children: React.ReactNode;
  gridTemplateColumns?: string | number | (string | number)[];
};

const FormRow = (props: FormRowProps): JSX.Element => {
  const { gridTemplateColumns, sx, children, ...rest } = props;
  const isGrid = !!gridTemplateColumns;

  return (
    <Box
      {...(rest as any)}
      className="form-row"
      sx={{
        display: isGrid ? 'grid' : 'flex',
        gridTemplateColumns: isGrid ? gridTemplateColumns : undefined,
        gap: 3,
        ...sx,
        '@media screen and (max-width:52em)': {
          flexDirection: 'column',
          gridTemplateColumns: isGrid ? '1fr' : undefined,
        },
        '> .form-column': {
          flex: isGrid ? undefined : 1,
          mt: isGrid ? 0 : undefined,
          '@media screen and (max-width:52em)': { flexGrow: 0 },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default FormRow;
